export default function getObjByCategory ( category ) {

  let obj = { name: category }

  switch ( category ) {

    case 'UserGroup':
      obj.get_url = '/api/W_UserGroup_Get.php';
      obj.post_url = '/api/W_UserGroup_Post.php';
      obj.update_url = '/api/W_UserGroup_Update.php';
      obj.remove_url = '/api/W_UserGroup_Delete.php';
      // obj.width = 600;
      obj.column_name = '使用者群組';
      obj.column_color = '色碼';
      break;
    case 'Zone':
      obj.get_url = '/api/W_Zone_Get.php';
      obj.post_url = '/api/W_Zone_Post.php';
      obj.update_url = '/api/W_Zone_Update.php';
      obj.remove_url = '/api/W_Zone_Delete.php';
      // obj.width = 300;
      obj.column_name = '區域';
      break;
    case 'Industry':
      obj.get_url = '/api/W_Industry_Get.php';
      obj.post_url = '/api/W_Industry_Post.php';
      obj.update_url = '/api/W_Industry_Update.php';
      obj.remove_url = '/api/W_Industry_Delete.php';
      // obj.width = 300;
      obj.column_name = '行業';
      break;
    case 'Trade':
      obj.get_url = '/api/W_Trade_Get.php';
      obj.post_url = '/api/W_Trade_Post.php';
      obj.update_url = '/api/W_Trade_Update.php';
      obj.remove_url = '/api/W_Trade_Delete.php';
      // obj.width = 300;
      obj.column_name = '產業';
      break;
    case 'WorkNature':
      obj.get_url = '/api/W_WorkNature_Get.php';
      obj.post_url = '/api/W_WorkNature_Post.php';
      obj.update_url = '/api/W_WorkNature_Update.php';
      obj.remove_url = '/api/W_WorkNature_Delete.php';
      // obj.width = 300;
      obj.column_name = '工作性質';
      break;
    case 'ProgressStatus':
      obj.get_url = '/api/W_ProgressStatus_Get.php';
      obj.post_url = '/api/W_ProgressStatus_Post.php';
      obj.update_url = '/api/W_ProgressStatus_Update.php';
      obj.remove_url = '/api/W_ProgressStatus_Delete.php';
      // obj.width = 300;
      obj.column_name = '工作進度';
      break;
    case 'ProjectProgress':
      obj.get_url = '/api/W_ProjectProgress_Get.php';
      obj.post_url = '/api/W_ProjectProgress_Post.php';
      obj.update_url = '/api/W_ProjectProgress_Update.php';
      obj.remove_url = '/api/W_ProjectProgress_Delete.php';
      // obj.width = 300;
      obj.column_name = '專案進度';
      break;
    case 'NewsType':
      obj.get_url = '/api/W_News_Type_Get.php';
      obj.post_url = '/api/W_News_Type_Post.php';
      obj.update_url = '/api/W_News_Type_Update.php';
      obj.remove_url = '/api/W_News_Type_Delete.php';
      // obj.width = 300;
      obj.column_name = '最新消息類型';
      break;
    case 'FileProperty':
      obj.get_url = '/api/W_FileProperty_Get.php';
      obj.post_url = '/api/W_FileProperty_Post.php';
      obj.update_url = '/api/W_FileProperty_Update.php';
      obj.remove_url = '/api/W_FileProperty_Delete.php';
      // obj.width = 300;
      obj.column_name = '檔案屬性名稱';
      break;
    case 'FilePropertyValue':
      obj.get_url = '/api/W_FilePropertyValue_Get.php';
      obj.post_url = '/api/W_FilePropertyValue_Post.php';
      obj.update_url = '/api/W_FilePropertyValue_Update.php';
      obj.remove_url = '/api/W_FilePropertyValue_Delete.php';
      // obj.width = 600;
      obj.column_name = '檔案屬性值內容';
      obj.column_parent = '檔案屬性名稱';
      // obj.column3 = 'is_used';
      break;
    // case 'FormStatus':
    //   obj.get_url = '/api/W_ServiceSky_RepairSky_Status_Lang_Get.php';
    //   obj.post_url = '/api/W_ServiceSky_RepairSky_Status_Lang_Post.php';
    //   obj.update_url = '/api/W_ServiceSky_RepairSky_Status_Lang_Update.php';
    //   obj.remove_url = '/api/W_ServiceSky_RepairSky_Status_Lang_Delete.php';
    //   // obj.width = 300;
    //   obj.column_name = '表單狀態';
    //   break;
    // case 'FormType':
    //   obj.get_url = '/api/W_ServiceSky_RepairSky_Type_Lang_Get.php';
    //   obj.post_url = '/api/W_ServiceSky_RepairSky_Type_Lang_Post.php';
    //   obj.update_url = '/api/W_ServiceSky_RepairSky_Type_Lang_Update.php';
    //   obj.remove_url = '/api/W_ServiceSky_RepairSky_Type_Lang_Delete.php';
    //   // obj.width = 300;
    //   obj.column_name = '表單類型';
    //   break;
    // case 'Role':
    //   obj.get_url = '/api/W_Role_Get.php';
    //   obj.post_url = '/api/W_role_get_post.php';
    //   obj.update_url = '/api/W_role_get_update.php';
    //   obj.remove_url = '/api/W_role_get_delete.php';
    //   obj.width = 900;
    //   obj.column_name = '角色名稱';
    //   obj.column_parent = '父階角色';
    //   obj.column_department = '部門';
    //   break;
    default:
      break;
  }

  return obj;
}



// WEBPACK FOOTER //
// ./src/commonJS/getObjByCategory.js